import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=b3915022&"
import script from "./Facebook.vue?vue&type=script&lang=js&"
export * from "./Facebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3915022')) {
      api.createRecord('b3915022', component.options)
    } else {
      api.reload('b3915022', component.options)
    }
    module.hot.accept("./Facebook.vue?vue&type=template&id=b3915022&", function () {
      api.rerender('b3915022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Facebook.vue"
export default component.exports